import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/distinctUntilChanged';
import { App } from '../interfaces';
import { EventScheduleService } from '../services/event-schedule-service';
import * as React from 'react';
import { DayEvents } from './day-events';
import { DateTime } from 'luxon';

export class EventScheduleController implements App.Schedule.CalendarController {

  service = new EventScheduleService();
  config = {
    monthFormat: 'MMMM yyyy'
  };
  private _currentMoment = new BehaviorSubject<DateTime>(DateTime.local());
  currentMoment = this._currentMoment.asObservable();
  visibleRange = this.currentMoment.map(
    (currentMoment) => ({
      first: currentMoment.startOf('month', { useLocaleWeeks: true }).startOf('week', { useLocaleWeeks: true}),
      last: currentMoment.endOf('month', { useLocaleWeeks: true }).endOf('week', { useLocaleWeeks: true })
    })
  ).share();

  events = this.visibleRange.distinctUntilChanged().flatMap(
    (visibleRange) => {

      this._loading.next(true);

      const eventsObservable = this.service.fetchEvents(visibleRange.first, visibleRange.last);

      eventsObservable.toPromise().then(
          () => this._loading.next(false)
      );

      return eventsObservable;

    }
  ).share();

  private _loading = new BehaviorSubject<boolean>(false);
  loading = this._loading.asObservable();

  getEventsForDay(day: DateTime): Observable<App.EventListing[]> {

    const dayStart = day.startOf('day', { useLocaleWeeks: true});

    return this.events.map(
      (events) => events.filter(
        event => {

          return DateTime.fromJSDate(event.calendarItem.start_time).hasSame(dayStart, 'day');

        }
      )
    );

  }

  setCurrentMoment(currentMoment: DateTime) {

    this._currentMoment.next(currentMoment);

  }
  prevMonth() {

    this._currentMoment.take(1).subscribe(
      (val) => this._currentMoment.next(val.minus({ months: 1 }))
    );

  }

  nextMonth() {

    this._currentMoment.take(1).subscribe(
      (val) => this._currentMoment.next(val.plus({ months: 1 }))
    );

  }

  renderDayActions(date: DateTime) {

    return null;

  }

  renderDayEvents(date: DateTime) {

    return <DayEvents date={date} controller={this}></DayEvents>

  }

}


// WEBPACK FOOTER //
// ./resources/src/components/event-schedule/event-schedule-controller.tsx